import { call, takeEvery, put } from 'redux-saga/effects';
import { message } from 'antd';
import { getDashboardDataRequest } from '../Api/Dashboard';
import dashboard from '../Actions/dashboard';
import { startLoading, stopLoading } from '../LoadingHelper';
const { types } = dashboard;
const { setDashboardData } = dashboard.actions;

export function* getDashboardData({data}) {
    const loadingId = yield call(startLoading, 'dashboardLoading');
    let defaultValue = {cfdi: null,payments: null,payroll: null, efos: null}; 
    try {
        const response = yield call(getDashboardDataRequest, data);
        if(response.status === 'success' && response.data != null) {            
            defaultValue = {
                'cfdi':JSON.parse(response.data.cfdi),
                'payments':JSON.parse(response.data.payments),
                'payroll':JSON.parse(response.data.payroll),
                'efos':JSON.parse(response.data.efos)
            }
        }

        yield put(setDashboardData(defaultValue));    
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* dashboardSaga() {
    yield takeEvery(types.GET_DASHBOARD_DATA, getDashboardData);
}
